import * as React from 'react'
import { SVGProps } from 'react'

const Visa = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='34' height='12' viewBox='0 0 34 12' fill='none' {...props}>
    <g fill='#C9D0E3'>
      <path d='M14.282 11.18h-2.67L13.282.854h2.67l-1.67 10.326zM23.96 1.106a6.58 6.58 0 00-2.395-.44c-2.636 0-4.493 1.407-4.504 3.417-.022 1.483 1.33 2.307 2.34 2.801 1.033.505 1.384.835 1.384 1.286-.01.691-.835 1.01-1.604 1.01-1.066 0-1.637-.164-2.505-.549l-.351-.165-.374 2.318c.626.285 1.78.538 2.978.55 2.801 0 4.625-1.385 4.647-3.527.01-1.175-.703-2.076-2.241-2.812-.934-.472-1.506-.791-1.506-1.274.01-.44.484-.89 1.538-.89a4.536 4.536 0 011.988.395l.242.11.363-2.23zM27.509 7.521c.22-.593 1.066-2.889 1.066-2.889-.011.023.22-.604.35-.988l.188.89s.505 2.471.615 2.987h-2.22zM30.804.854H28.74c-.637 0-1.12.186-1.395.857l-3.966 9.468h2.801s.462-1.274.56-1.549h3.429c.076.363.318 1.55.318 1.55h2.472L30.804.853zM9.382.854L6.767 7.895l-.286-1.428c-.483-1.648-2-3.438-3.691-4.328l2.395 9.03h2.823L12.205.854H9.382z' />
      <path d='M4.34.854H.044L0 1.063c3.35.856 5.57 2.922 6.482 5.404l-.934-4.745c-.154-.66-.626-.846-1.208-.868z' />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path fill='#fff' d='M0 .667h33.333v10.667H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default Visa
